import { IThamSoHeThongActionTypes } from "../../action-types/category/IThamSoHeThongActions";
import { IThamSoHeThongReducer } from "../../reducer-model/category/IThamSoHeThongReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: IThamSoHeThongReducer = {
    status: eReducerStatusBase.is_not_initialization,
    thamSoHeThongs: []
}

export const thamSoHeThongReducer = (state: IThamSoHeThongReducer = iniState, action: IThamSoHeThongActionTypes): IThamSoHeThongReducer => {
    switch (action.type) {
        case "THAM_SO_HE_THONG_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            };
        case "THAM_SO_HE_THONG_LOAD_SUCCESS":
            return {
                ...state,
                 thamSoHeThongs: action.payload,
                 status: eReducerStatusBase.is_completed,
            };
        case "THAM_SO_HE_THONG_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        case "THAM_SO_HE_THONG_UPDATE_ACTIVE_STATUS_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            };
        case "THAM_SO_HE_THONG_UPDATE_ACTIVE_STATUS_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "THAM_SO_HE_THONG_UPDATE_ACTIVE_STATUS_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        case "THAM_SO_HE_THONG_SELECTED_THAM_SO":
            return {
                ...state,
                nhomThamSoSelected: action.payload
            };
        case "THAM_SO_HE_THONG_CHANGE_DATA":
            const updatedThamSoHeThongs = state.thamSoHeThongs.map(item => {
                if (item.id === action.payload.id) {
                    return { ...item, ...action.payload };
                }
                return item;
            });
            return {
                ...state,
                thamSoHeThongs: updatedThamSoHeThongs,
                listIdsChange: [...(state.listIdsChange || []), action.payload.id]
            };
        case "THAM_SO_HE_THONG_UPDATES_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            };
        case "THAM_SO_HE_THONG_UPDATES_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                listIdsChange: []
            };
        case "THAM_SO_HE_THONG_UPDATES_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        default:
            return state;
    }
}